import { createSortOption } from "@nosto/preact"
export const sizes = [36, 48, 72]

const isMobile = window.innerWidth < 769;

export const sortOptions = [
    createSortOption("score", "Featured", { field: "score", order: "desc" }),
    // createSortOption("-price", "Price descending", { field: "price", order: "desc" }),
    // createSortOption("price", "Price ascending", { field: "price", order: "asc" }),
    createSortOption("stats.revenue", "Best selling", { field: "stats.revenue", order: "desc" }),
    createSortOption("name", "Alphabetically, A-Z", { field: "name", order: "asc" }),
    createSortOption("-name", "Alphabetically, Z-A", { field: "name", order: "desc" }),
    createSortOption("price", "Price: low to high", { field: "price", order: "asc" }),
    createSortOption("-price", "Price: high to low", { field: "price", order: "desc" }),
    createSortOption("date published", "Date, old to new", { field: "datePublished", order: "asc" }),
    createSortOption("-date published", "Date, new to old", { field: "datePublished", order: "desc" }),
]

export const defaultConfig = {
    sort: sortOptions[0],
    serpSize: sizes[0],
    autocompleteProductsSize: isMobile ? 2 : 4,
    autocompleteKeywordsSize: 5,
    historySize: 5
}
